import { AccessChecker } from 'mycorems-app-accounts';
import rules from './rules';

const accessChecker = new AccessChecker(rules, 'cm_reports');

export default function (action: string, ...args: any[]): boolean {
  return accessChecker.isGranted(action, ...args);
}
